import { IconDefinition } from '@ant-design/icons-angular';

export const MoonFill: IconDefinition = {
    name: 'moon',
    theme: 'fill',
    icon: '<svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false"><path d="M489.5 111.66c30.65-1.8 45.98 36.44 22.58 56.33A243.35 243.35 0 00426 354c0 134.76 109.24 244 244 244 72.58 0 139.9-31.83 186.01-86.08 19.87-23.38 58.07-8.1 56.34 22.53C900.4 745.82 725.15 912 512.5 912 291.31 912 112 732.69 112 511.5c0-211.39 164.29-386.02 374.2-399.65l.2-.01z" /></svg>'
}